import React, { CSSProperties, useEffect, useRef } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { animate } from 'framer-motion';

interface CounterType {
  from:number,
  to:number,
  duration:number,
  format(value:string):string,
  style?:CSSProperties
}

const Counter :React.FC<CounterType> = ({
  from = 0, to = 0, duration = 1, format, style = {},
} : CounterType) => {
  const nodeRef = useRef<any>(null);

  useEffect(() => {
    const node = nodeRef.current;
    const controls = animate(from, to, {
      duration,
      type: 'spring',
      bounce: 0,
      onUpdate(value) {
        node.innerHTML = format(value.toFixed(0));
      },
    });
    return () => controls.stop();
  }, [from, to]);

  return <p style={style} ref={nodeRef} />;
};

export default Counter;
